import { toast } from "react-toastify";

// Toast configuration options
const toastConfig = {
  position: toast.POSITION.TOP_RIGHT,
  toastClassName: "my-toast",
  bodyClassName: "my-toast-body",
  closeButton: false,
  autoClose: 1500, // Close the toast automatically after 5 seconds
};

export default toastConfig;
